import { Box, Drawer, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

interface LegendBottomSheetProps {
  open: boolean;
  onClose: () => void;
}

export const LegendBottomSheet = ({ open, onClose }: LegendBottomSheetProps) => {
  const colors = [
    { label: 'Свободен', color: '#181F28' },
    { label: 'Занят', color: '#1CBD91' },
    { label: 'Занят, без заказа', color: '#1CBD91', stripe: '#000000' },
    { label: 'Внимание', color: '#EAAA08' },
    { label: 'Опоздание', color: '#EA2727' },
    { label: 'Требуется действие', color: '#C62828', halfStripe: '#EA2727' },
    { label: 'Есть бронь', dot: '#EA2727' },
  ];

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      variant="temporary"
      PaperProps={{
        style: {
          maxHeight: 'calc(85vh - env(safe-area-inset-bottom))',
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          paddingBottom: 'env(safe-area-inset-bottom)',
        },
      }}
      className="design-v3-font"
    >
      <Box
        paddingX="20px"
        paddingTop="12px"
        paddingBottom="max(24px, env(safe-area-inset-bottom))"
        style={{
          overflowY: 'auto',
          maxHeight: 'calc(85vh - env(safe-area-inset-bottom) - 60px)',
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          marginBottom="16px"
          position="relative"
        >
          <Box
            width={40}
            height={4}
            borderRadius={2}
            bgcolor="rgba(0,0,0,0.2)"
            style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          />
          <Box flexGrow={1} />
          <IconButton
            onClick={onClose}
            size="small"
            style={{
              padding: 8,
            }}
          >
            <CloseIcon style={{ fontSize: 20 }} />
          </IconButton>
        </Box>

        <Box fontSize={18} fontWeight={600} marginBottom="20px" color="#181F28">
          Легенда статусов
        </Box>

        {colors.map((color) => {
          const style: React.CSSProperties = {
            width: 32,
            height: 32,
            borderRadius: 4,
            flexShrink: 0,
          };

          if (color.color) {
            style.background = color.color;
          }

          if (color.stripe) {
            style.background = `repeating-linear-gradient(
              -45deg,
              ${color.stripe} 0 4px,
              transparent 4px 8px
            ), ${color.color}`;
          }

          if (color.halfStripe) {
            style.background = `linear-gradient(
              135deg,
              ${color.halfStripe} 50%,
              ${color.color} 50%
            )`;
          }

          let markerElement: React.ReactElement;
          if (color.dot) {
            markerElement = (
              <Box
                width={32}
                height={32}
                borderRadius={4}
                bgcolor="#FFFFFF"
                border="1px solid rgba(0,0,0,0.1)"
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={style}
              >
                <Box width={12} height={12} borderRadius="50%" bgcolor={color.dot} />
              </Box>
            );
          } else {
            markerElement = <Box style={style} />;
          }

          return (
            <Box
              key={color.label}
              display="flex"
              alignItems="center"
              gridGap="12px"
              padding="12px 0"
              style={{ minHeight: 44 }}
            >
              {markerElement}
              <Box fontSize={16} fontWeight={400} color="#181F28" lineHeight={1.4}>
                {color.label}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Drawer>
  );
};
